import { SVGProps } from 'react';

const Vegan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 8q6 0 6-6-6 0-6 6m0 0c-2.5 4.5-3.1 7.18-4 14A26.6 26.6 0 0 0 2 2m15.41 1.59a10 10 0 1 0 3 3"
    />
  </svg>
);
export default Vegan;
